export default {"src":"/_next/static/media/Bsky.5d461229.svg","height":37,"width":37,"blurWidth":0,"blurHeight":0};